import { IntlFormatters } from "react-intl";
import { IDoPos, IKeyChange } from "../../../../../common/types";
import { IAccidental } from "../../score-display/utils";
import messages from "./messages";

export const getModulationOptions = (currentDoPos: IDoPos) => {
    return Array.from({ length: 15 }).map((_, index) => {
        const key = index - 7;
        const value = key - currentDoPos.i;
        return {
            value,
            label: value > 0 ? `+${value}` : value.toString(),
        }
    })
}

export const getNewDoPosOctave = (currentOctave: number, autoDirection: 1 | -1 | 0, keyChangeDirection: 1 | -1) => {
    let newDoPostOctave = currentOctave;
    if (autoDirection === 0 || autoDirection === keyChangeDirection) {
        newDoPostOctave = currentOctave;
    } else if (autoDirection > keyChangeDirection) {
        newDoPostOctave = currentOctave - 1;
    } else if (autoDirection < keyChangeDirection) {
        newDoPostOctave = currentOctave + 1;
    }
    return Math.min(5, Math.max(1, newDoPostOctave)) as IDoPos["o"];
}

export const getModulationDirectionOptions = (formatMessage: IntlFormatters["formatMessage"]) =>
    [
        {
            label: formatMessage(messages.up),
            value: 1
        }, {
            label: formatMessage(messages.down),
            value: -1
        }
    ];

export const getDefaultKeyChange = (keyChanges: IKeyChange[], bar: number, currentDoPos: IAccidental): {
    amount: number,
    direction: 1 | -1,
} => {
    const existingKeyChange = (keyChanges || []).find(kc => kc.bar === bar);
    if (!!existingKeyChange) {
        return existingKeyChange;
    }
    return {
        amount: currentDoPos.i < 7 ? 1 : -1,
        direction: 1,
    };
}